import { ApplyButton, SectionHeader } from "./shared";
import creditImage from "../../assets/home/credit-score.jpg";

export default function HomeCreditScore() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] pt-[60px] pb-[60px] lg:pb-[150px]">
      <div className="max-w-[1280px] mx-auto">
        <SectionHeader
          badge="Know Your Credit Score"
          title="Know Your Credit Score. Take Control of Your Financial Future."
        />

        <div className="mt-10 lg:mt-[106px] flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-[43px]">
          <div className="w-full lg:w-[688px] shrink-0 h-[240px] sm:h-[360px] rounded-[24px] overflow-hidden bg-[#f8fafc]">
            <img src={creditImage} alt="Credit score report" loading="lazy" className="size-full object-cover" />
          </div>
          <div className="lg:w-[481px] lg:pt-[68px]">
            <div className="flex flex-col gap-5 text-[#6a7282] text-[16px] leading-[26px]">
              <p>
                Understand your credit health and make more informed borrowing decisions. Check your credit score and take the next step toward your financial goals with FastRupees.
              </p>
              <p>Quick, simple and secure. Checking your score does not guarantee loan approval.</p>
            </div>
            <ApplyButton
              label="Check My Credit Score"
              location="credit_score"
              arrow={false}
              className="mt-8 px-6 py-3 w-full sm:w-[228px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
